// extracted by mini-css-extract-plugin
export var isActive = "toggle-module--is-active--16a49";
export var isDarkmode = "toggle-module--is-darkmode--07371";
export var toggle = "toggle-module--toggle--b2192";
export var toggle__button = "toggle-module--toggle__button--a2ae5";
export var toggle__label = "toggle-module--toggle__label--0efaf";